export default __webpack_public_path__ + "static/media/brand-11.3a319f51.png";